export default __webpack_public_path__ + "static/media/cpv_76_oil-and-gass.57895cd7.svg";